var cal = {
    video_play: function() {
        console.log('gaurv');
        var $button = $('.video-section__poster');
        var button = $button[0];
        var rect = button.getBoundingClientRect();
        var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
        if (!(rect.bottom < 0 || rect.top - viewHeight >= 0)) {
            $button.trigger('click')
        }
    },
    product_descrioption: function() {
        var $textDiv = $('#text');
        var $toggleButton = $('#toggleButton');
        var $toggleHideShow = $('.toggle_hide_show');
        var $contentToToggle = $toggleHideShow.nextAll();
        $contentToToggle.addClass('hidden');
        $toggleButton.click(function() {
            if ($contentToToggle.hasClass('hidden')) {
                $contentToToggle.removeClass('hidden');
                $toggleButton.text('Show Less')
            } else {
                $contentToToggle.addClass('hidden');
                $toggleButton.text('Read More')
            }
        })
    }
}

$(function(){cal.product_descrioption();var pay_video=!0;$(window).on('scroll',function(){});function video_play(){var $button=$('.video-section__poster');var button=$button[0];var rect=button.getBoundingClientRect();var viewHeight=Math.max(document.documentElement.clientHeight,window.innerHeight);if(!(rect.bottom<0||rect.top-viewHeight>=0)){if(pay_video){console.log(pay_video);$button.trigger('click');pay_video=!1;setTimeout(function(){var video=$('.ideo-section video').trigger('click')},100)}}}})

document.addEventListener('DOMContentLoaded', function() {
    const headerWrapper = document.querySelector('sticky-header');
    if (headerWrapper) {
        // Calculate header height and set as CSS custom property
        const headerHeight = headerWrapper.offsetHeight;
        document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    }
});

window.addEventListener('scroll', function() {
    const header = document.querySelector('sticky-header');
    const main = document.querySelector('main');
    if (window.scrollY >= 50) {
        header.classList.add('sticky-header');
        main.classList.add('main-padded');
    } else {
        header.classList.remove('sticky-header');
        main.classList.remove('main-padded');
    }
});

$(document).ready(function() {
  function initializeSlider(sliderElement, options) {
    if (!sliderElement.hasClass('slick-initialized')) {
      sliderElement.slick(options);
    }
  }

  function destroySlider(sliderElement) {
    if (sliderElement.hasClass('slick-initialized')) {
      sliderElement.slick('unslick');
    }
  }

  var carouselSliderOptions = {
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  // Handle Shopify section events
  $(document).on('shopify:section:load shopify:section:unload', function(event) {
    var sectionId = event.detail.sectionId;
    var sectionElement = $('#shopify-section-' + sectionId);
    var carouselSliders = sectionElement.find('.carousel');

    carouselSliders.each(function() {
      destroySlider($(this));
      initializeSlider($(this), carouselSliderOptions);
    });
  });

  // Initial initialization
  initializeSlider($('.carousel'), carouselSliderOptions);
});

  function showPopup(element) {
      const popup = document.getElementById('popup');
      const popupContent = document.getElementById('popupContent');
      const type = element.getAttribute('data-popup-type');
      const content = element.getAttribute('data-popup-content');

      if (type === 'video') {
        popupContent.innerHTML = `<video autoplay playsinline><source src="${content}" type="video/mp4"></video>`;
      } else if (type === 'image') {
        popupContent.innerHTML = `<img src="${content}" alt="Popup Image">`;
      }
      popup.style.display = 'flex';
      document.body.classList.add('no-scroll');
    }

    function closePopup() {
      const popup = document.getElementById('popup');
      const popupContent = document.getElementById('popupContent');
      const video = popupContent.querySelector('video');
      if (video) video.pause();
      popupContent.innerHTML = '';
      popup.style.display = 'none';
      document.body.classList.remove('no-scroll');
    }